import i18n from 'resources/locales/i18n'

export const PatientsListTypes = {
  NeedsAttention: {
    type: 'needsAttention',
    title: i18n.t('pages.copilotControl.widgets.needsAttention.title')
  },
  PatientsSentiment: {
    type: 'patientsSentiment',
    title: i18n.t('pages.copilotControl.widgets.patientsSentiment.title')
  },
  ScanningSchedule: {
    type: 'scanningSchedule',
    title: i18n.t('pages.copilotControl.widgets.scanningSchedule.title')
  }
}
export const CopilotEngagementTypes = {
  PatientsSentiment: 'patientsSentiment',
  ScanningSchedule: 'scanningSchedule'
}

export const CopilotEngagementCategories = {
  Negative: 'negative',
  Neutral: 'neutral',
  Positive: 'positive'
}
